import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './estilo-maqueta.css';
import './estilos.css';

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('No se ha encontrado el nodo raiz de la aplicacion.');

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
